import styled from '@emotion/styled'

import { Text } from 'main/ui'
import { colors, palette, spacing } from 'main/ui/constants'

export const Container = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  height: ${spacing.minorScale(8)}px;
  justify-content: space-around;
  align-items: center;
  position: relative;
  width: ${spacing.minorScale(25)}px;
  max-width ${spacing.minorScale(25)}px;
  border-color: ${colors.border.default}};
`

export const IconContainer = styled.div`
  color: ${colors.text.hint};
  margin: auto 0;
  width: 12px;
`

export const StyledSelect = styled.select`
  appearance: none;
  background-color: transparent;
  border: none;
  box-shadow: none;
  color: ${colors.text.hint};
  height: ${spacing.minorScale(8)}px;
  line-height: 22px;
  outline-style: none;

  &:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 #000;
  }

  // HACK: Workaround left padding that Firefox applies to select elements.
  @-moz-document url-prefix() {
    text-indent: -2px;
  }

  // HACK (alex): cross-bundle compatibility
  background: none;
  margin-bottom: 0;
  padding: 0;
  &:focus {
    background: none;
    border: none;
    outline: none;
  }
`

export const CaretIconContainer = styled.div`
  color: ${palette.mediumGray};
  width: ${spacing.minorScale(2)}px;
  height: ${spacing.minorScale(1)}px;
`

export const StyledText = styled(Text)`
  color: ${palette.slate};
  font-size: 14px;
`
